import LabServiceModel from "@/models/LabServiceModel";

export default class PermissionModel extends LabServiceModel {
  modelName() {
    return "work-group/permissions";
  }
  defaults() {
    return {
      id: null,
      name: null,
      guard_name: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
    };
  }
  mutations() {
    return {
      id: (val) => this.nullNumberMutator(val),
      name: (val) => this.nullStringMutator(val),
      guard_name: (val) => this.nullStringMutator(val),
      created_at: String,
      updated_at: String,
      deleted_at: String,
    };
  }
  validation() {
    return {};
  }
}
